import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="mb-6">
        <Link to="/" className="text-primary hover:underline">&larr; Back Home</Link>
      </div>
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <div className="prose prose-gray max-w-none">
        <p className="mb-4">Last updated: February 2024</p>
        
        <h2 className="text-2xl font-semibold mt-6 mb-4">1. Introduction</h2>
        <p>Welcome to UPnGOTrainerPad. We respect your privacy and are committed to protecting your personal data.</p>
        
        <h2 className="text-2xl font-semibold mt-6 mb-4">2. Data We Collect</h2>
        <p>We collect information that you provide directly to us, including:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>Contact information (name, email address)</li>
          <li>Profile information</li>
          <li>Usage data and preferences</li>
        </ul>
        
        <h2 className="text-2xl font-semibold mt-6 mb-4">3. How We Use Your Data</h2>
        <p>We use your personal data to:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>Provide and maintain our services</li>
          <li>Notify you about changes to our services</li>
          <li>Provide customer support</li>
          <li>Monitor usage of our services</li>
        </ul>
        
        <h2 className="text-2xl font-semibold mt-6 mb-4">4. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, please contact us at:</p>
        <p>Email: info@upngoTrainerPad.co.uk</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;